import React, { FC, useState, useCallback } from 'react';
import { Table, TableFooter, TableRow, TablePagination, Grid, Button, IconButton } from '@material-ui/core';
import { ArrowBack, ArrowForward } from '@material-ui/icons';

interface Props {
  pagination: 'showMore' | 'pages';
  translation: any;
  hasMore?: boolean;
  visibleCount?: number;
  totalCount?: number;
  onShowMore?: () => void;
  rowsPerPage?: number;
  rowCount?: number;
  onPageChange?: (pageNumber: number) => void;
}

export const DataTableFooter: FC<Props> = ({ pagination, translation, hasMore, visibleCount, totalCount, onShowMore, rowsPerPage = 500, rowCount = 0, onPageChange }) => {
  const [pageNumber, setPageNumber] = useState(0);

  const handlePageChange = useCallback(
    (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
      setPageNumber(newPage);
      if (onPageChange) onPageChange(newPage + 1);
    },
    [onPageChange],
  );

  if (pagination === 'showMore') {
    if (!totalCount || totalCount === 0 || !hasMore) return null;

    return (
      <Grid item xs={12}>
        <Grid container direction="row" justify="center" alignContent="center" alignItems="center">
          <Grid item>
            <p>
              {translation.text_6436} {`1 - ${visibleCount} ${translation.of} ${totalCount}`}
            </p>
          </Grid>
          <Grid item>
            <Button onClick={onShowMore}>{translation.text_6439}</Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  if (pagination === 'pages' && onPageChange && rowCount > rowsPerPage) {
    return (
      <Table size="small">
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[rowsPerPage]}
              count={rowCount === 0 ? 0 : -1}
              rowsPerPage={rowsPerPage}
              page={pageNumber}
              labelDisplayedRows={({ from, to, count, page: p }) => (count === 0 && (p === 0 || p > 0) ? '' : `Displaying ${from}-${to} results `)}
              onChangePage={handlePageChange}
              ActionsComponent={(props) => (
                <Grid container alignItems="center" justify="flex-end">
                  <Grid item>
                    <IconButton disabled={props.page === 0} onClick={(e) => props.onChangePage(e, props.page - 1)}>
                      <ArrowBack />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton onClick={(e) => props.onChangePage(e, props.page + 1)}>
                      <ArrowForward />
                    </IconButton>
                  </Grid>
                </Grid>
              )}
            />
          </TableRow>
        </TableFooter>
      </Table>
    );
  }

  return null;
};
